import {
  RDFS_LABEL_IRI,
  SCHEMA_ORG_DATE_PUBLISHED_IRI,
  XSD_DATE_TIME_IRI,
} from 'src/templates/queries/iris';
import { getAbbreviationOrFullIri } from 'src/utils/getAbbreviationOrFullIri';

export const stringifyProjectMetadata = (
  namedGraph: string,
  label: string,
  publishedDate: number,
  namespaces: Record<string, string>
) => {
  const rdfsLabel = getAbbreviationOrFullIri(RDFS_LABEL_IRI, namespaces);
  const schemaOrgDatePublished = getAbbreviationOrFullIri(
    SCHEMA_ORG_DATE_PUBLISHED_IRI,
    namespaces
  );
  const isoDate = new Date(publishedDate).toISOString();
  const xsdDateTime = getAbbreviationOrFullIri(XSD_DATE_TIME_IRI, namespaces);
  return `\
<${namedGraph}> {
  <${namedGraph}> ${rdfsLabel} "${label}" .
  <${namedGraph}> ${schemaOrgDatePublished} "${isoDate}"^^${xsdDateTime} .
}`;
};
